import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
if(window.self===window.top){
   window.location.href="https://administrador.upaxer.com/";
 }
ReactDOM.render(
    <App/>,
    document.getElementById('root')
);